import {
  CampaignSummaryState,
  CampaignSummaryActions,
  GET_CAMPAIGN_SUMMARIES_PENDING,
  GET_CAMPAIGN_SUMMARIES_SUCCESS,
  GET_CAMPAIGN_SUMMARIES_FAILURE,
  ABORT_GET_CAMPAIGN_SUMMARIES
} from "./types";

export const campaignSummaryInitialState: CampaignSummaryState = {
  cancellationSource: null,
  lastReceived: null,
  data: [],
  error: null
};

export const campaignSummaryReducer = (
  state = campaignSummaryInitialState,
  action: CampaignSummaryActions
): CampaignSummaryState => {
  switch (action.type) {
    case GET_CAMPAIGN_SUMMARIES_PENDING:
      return {
        ...state,
        cancellationSource: action.meta.cancellationSource,
        error: null
      };
    case GET_CAMPAIGN_SUMMARIES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        cancellationSource: null,
        lastReceived: action.meta.timestamp,
        error: null
      };
    case GET_CAMPAIGN_SUMMARIES_FAILURE:
      return {
        ...state,
        cancellationSource: null,
        error: action.meta.error
      };
    case ABORT_GET_CAMPAIGN_SUMMARIES:
      return {
        ...state,
        cancellationSource: null
      };
    default:
      return state;
  }
};
